import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy,
  ChangeDetectorRef
} from "@angular/core";
import { DataService } from "./data.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import * as HSET from "./settings";
import { WidgetConfig } from "../../../class/widget-config";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GenericUtils } from './../../../utilities/generic-utils';
addMore(Highcharts);
@Component({
  selector: 'widget-stacked-column-chart',
  templateUrl: './widget-stacked-column-chart.component.html',
  styleUrls: ['./widget-stacked-column-chart.component.scss'],
  providers: [DataService]
})
export class WidgetStackedColumnChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;
  loadingChart = false;
  errorLoadingChart = false;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private translateService: TranslateService,
    private dataService: DataService,
    private cd : ChangeDetectorRef,
    private genericUtils: GenericUtils
  ) {}

  

  ngOnChanges(changes: SimpleChanges) {
      this.getData();
  }

  ngOnInit() {}

  getData() {
    this.chartOptions = null;
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.errorLoadingChart = false;
    const queryParams = { ...this.FILTERS};
    this.dataService.getData(this.WIDGETCONFIG.api, this.WIDGETCONFIG, queryParams)
    .pipe(takeUntil(this.unsubscribe)).subscribe(
      chartData => {
        this.loadingChart = false;
        if (chartData) {
          this.chartOptions = this.dataService.createChart(
            chartData,
            this.CHARTCONFIG
          );
        } else {
          this.handleError("ERROR_MSG.NO_DATA");
        }
      },
      error => {
        this.loadingChart = false;
        this.handleError("ERROR_MSG.SYSTEM_ERROR");
      }
    );
  }

  handleError(message) {
    this.errorLoadingChart = true;
    this.errorMessage = message;
    this.mockChart = [{ chart: HSET.chartData, width: 12 }];

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
